import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import './SupplierGoodsServices.scss';
import SortService from '../Shared/sort.service';
import { Highlight } from 'react-instantsearch-dom';

const SupplierGoodsServices = ({ supplierId, services, truncateCount, useEllipsis, hit}) => {
  const isTruncated = truncateCount !== undefined;

  const servicesHtml = getServicesHtml(
    services,
    isTruncated,
    truncateCount,
    useEllipsis,
    supplierId,
    hit
  );
  const goodsServicesListClassNames = initializeGoodsServicesListClasses(
    useEllipsis
  );

  const suppliersInfo = {
    services,
    suppliers: services && Array.isArray(services) && services.length > 0? services?.map((service, i) => { return { index: service?.id, nigpCode: service?.description, _highlightResult: hit && Array.isArray(hit) ? hit[i] : null };  }) : [],
     nigpCodeDescriptions: services.nigpCode?.map(n => n?.description) || []
  };


  const normalizedSuppliers = suppliersInfo?.suppliers?.map(s => ({
  ...s,
  nigpCodeDescription: s?.nigpCode,
    description: s?.nigpCode,
    _highlightResult: s?._highlightResult
}));

/*   console.log('hit', hit);
  var arr = hit?.nigpCode ? hit.nigpCode : null;
  var hasHighlight = arr?.find(x => x?.description?.matchLevel !== 'none'); //?.find(description => description.matchLevel === 'full') ? hit._highlightResult?.nigpCode?.find(description => description.matchLevel === 'full')?.description?.value : null;
  console.log('hasHighlight', hasHighlight);
  console.log('suppliersInfo11', suppliersInfo);

  console.log('normalizedSuppliers', normalizedSuppliers); */

      return (
    <div>
      <h5>Goods and Services</h5>
      <ul className={goodsServicesListClassNames}>
        {servicesHtml}
      </ul>
    </div>
  );
  

  return (
    <div>
      <h5>Goods and Services</h5>
      <ul className={goodsServicesListClassNames}>
        {servicesHtml}
      </ul>
    </div>
  );
}

function getServicesHtml(
  services,
  isTruncated = false,
  truncateCount = 4,
  useEllipsis,
  supplierId,
  hit
) {

/*   console.log('services', services);
  console.log(' Array.isArray(services)',  Array.isArray(services));
  console.log('hit', hit); */
  const suppliersInfo = {
    services,
    suppliers: services && Array.isArray(services) && services.length > 0? services?.map((service, i) => { return { index: service?.id, nigpCode: service?.description, _highlightResult: hit && Array.isArray(hit) ? hit[i] : null };  }) : [],
    nigpCodeDescriptions: services.nigpCode?.map(n => n?.description) || []
  };


  const normalizedSuppliers = suppliersInfo?.suppliers?.map(s => ({
  ...s,
  nigpCodeDescription: s?.nigpCode,
    description: s?.nigpCode,
    _highlightResult: s?._highlightResult,
    hasHighlight: s  ? s?._highlightResult?.description?.matchLevel !== 'none' : false
}));

  //console.log('normalizedSuppliers11', normalizedSuppliers);

  // Remove duplicate services.
  const distinctServices = new Set(
    services.map(service => service.description)
  );

  //console.log('distinctServices', distinctServices);

  //let's sort hits first,
  const sortedGoodServices = [];



  const sortList = normalizedSuppliers.sort((a, b) => {
  // 1. Prioritize hasHighlight = true
  if (a.hasHighlight !== b.hasHighlight) {
    return b.hasHighlight - a.hasHighlight;
  }

  // 2. Alphabetical within each group
  return a.description.localeCompare(b.description);
});

  if(sortedGoodServices.length > 0) {
   // console.log('sortedGoodServices with highlights on top', sortedGoodServices);
  } else {    

      let arr = Array.from(distinctServices);
      let rec1 = normalizedSuppliers?.find(s => s?.description === arr[0]);
    sortedGoodServices.push({ ...rec1, description: rec1?.description, hasHighlight: rec1?.hasHighlight });
  }

  //console.log('sortList', sortList);
  


  const servicesHtml = [];

  let count = 0;

/*   for (const service of sortedServices) {
    let listItemHtml = <li key={service}>{service}</li>; */
    
    
  for (const service of sortList) {
    let listItemHtml = <li key={service.index}>{service.description}</li>;  

    //console.log('useEllipsis', useEllipsis);

      if (useEllipsis) {

        
      if (service?.hasHighlight) {   

        listItemHtml = (
          <li key={service.index}>
            <Tooltip title={service.description} placement="bottom-start">    
              <span>
                <Highlight hit={service} attribute="description" />
              </span> 
            </Tooltip>
          </li>
        );
      }
      else {
        listItemHtml = (
          <li key={service.index}>
               <Highlight hit={service} attribute="description" />
          </li>
        );
      }


      }


    servicesHtml.push(listItemHtml);
    count++;

    if (isTruncated && count === truncateCount) {
      servicesHtml.push(
        <li key="more" className="more">
          <Link aria-label="Show more suppliers"
            to={{
              pathname: `/supplier/${supplierId}`,
            }}
          >
           Show more suppliers
          </Link>
        </li>
      );
      break;
    }
  }

  return servicesHtml;
}

function initializeGoodsServicesListClasses(useEllipsis) {
  const listClasses = ['supplier-goods-services'];

  if (useEllipsis) {
    listClasses.push('use-ellipsis');
  }

  return listClasses.join(' ');
}

export default SupplierGoodsServices;